import { ZeroResultsEnhancementType } from '../../providers/constants'
import {
  CARELON_PROVIDER_DIRECTORY_FEATURE_FLAGS,
  CARELON_PROVIDER_DIRECTORY_PLACEMENTS,
  CARELON_PROVIDER_DIRECTORY_TREATMENT_GROUPS,
} from '../constants'

import type { CarelonDirectoryCustomerConfiguration, CarelonDirectoryEligibilityRule } from '../types'

const medicationRule: CarelonDirectoryEligibilityRule = {
  treatmentGroup: CARELON_PROVIDER_DIRECTORY_TREATMENT_GROUPS.MEDICATION_MANAGEMENT,
  recommendationTierScope: { type: 'unrestricted' },
  searcherPolicy: 'all',
}

const outpatientTherapyRule: CarelonDirectoryEligibilityRule = {
  treatmentGroup: CARELON_PROVIDER_DIRECTORY_TREATMENT_GROUPS.OUTPATIENT_THERAPY,
  recommendationTierScope: { type: 'unrestricted' },
  searcherPolicy: 'excludeSelfInitiatedTeen',
  requiredFeatureFlag: CARELON_PROVIDER_DIRECTORY_FEATURE_FLAGS.OUTPATIENT_THERAPY,
}

const providerSearchRules = [medicationRule, outpatientTherapyRule]

export const uphsCarelonDirectoryConfiguration: CarelonDirectoryCustomerConfiguration = {
  directoryUrl: 'https://www.carelonbh.com/uphs/en/home/find-providers',
  placements: {
    [CARELON_PROVIDER_DIRECTORY_PLACEMENTS.PROVIDER_RESULTS]: providerSearchRules,
    [CARELON_PROVIDER_DIRECTORY_PLACEMENTS.CONSOLIDATED_CARE_NAVIGATOR]: providerSearchRules,
    [CARELON_PROVIDER_DIRECTORY_PLACEMENTS.ENHANCED_ZERO_RESULTS]: [
      {
        ...medicationRule,
        enhancementTypes: [
          ZeroResultsEnhancementType.TIER_1_AND_2_THERAPY,
          ZeroResultsEnhancementType.TIER_3_AND_OTHER_PROGRAMS,
        ],
      },
      {
        ...outpatientTherapyRule,
        enhancementTypes: [
          ZeroResultsEnhancementType.TIER_1_AND_2_THERAPY,
          ZeroResultsEnhancementType.TIER_3_AND_OTHER_PROGRAMS,
        ],
      },
    ],
  },
}
